import React from 'react';
import { Link } from 'react-router-dom';
import {
  Typography
} from '@material-ui/core';


const InfoCard = ({
  title,
  subTitle,
  icon,
  link,
  isExternalLink
}) => {
  return (
    <div className="neomorphs-card card">
      {isExternalLink ?
        <a
          href={link}
          rel="noreferrer noopener"
          target="_blank"
        >
          <div className="neomorphs-icon">
            {icon}
          </div>
          <Typography
            variant="h4"
            className="h4 font-semibold mt-4"
          >
            <div dangerouslySetInnerHTML={{ __html: title }} />
          </Typography>
          <Typography
            variant="body1"
            className="sub-title"
          >
            {subTitle}
          </Typography>
        </a>
        :
        <Link
          to={link}
        >
          <div className="neomorphs-icon">
            {icon}
          </div>
          <Typography
            variant="h4"
            className="h4 font-semibold mt-4"
          >
            <div dangerouslySetInnerHTML={{ __html: title }} />
          </Typography>
          <Typography
            variant="body1"
            className="sub-title"
          >
            {subTitle}
          </Typography>
        </Link>
      }
    </div>
  );
};

export default InfoCard;
